// Header não-secreto que identifica a origem das chamadas como o app web do
// motor de reservas — usado pelo servidor para distinguir o app de bots/scrapers.
export const CLIENT_HEADER_NAME = 'X-Hqbookings-Client';
export const CLIENT_HEADER_VALUE = 'web';
